export default {
    title: "Benefits center",
    loadError: "Could not load the benefits center.",
    saveError: "Could not save the benefits center.",
    saveSuccess: "Settings saved successfully.",
    preview: {
        title: "Preview",
        placeholder: "Reserved space for the preview",
        screenLogin: "Login",
        screenApp: "App",
        link: "Access link",
        linkCopied: "Link copied",
        open: "View preview",
        close: "Close preview",
    },
    tabs: {
        label: "Benefits center sections",
        settings: "Settings",
        tiers: "Tiers",
        points: "Points program",
        referrals: "Referrals",
        cashback: "Cashback",
        empty: "This section will be configured in the next steps.",
        comingSoon: "Coming soon",
    },
    settings: {
        clubName: "Club name",
        clubNameRequired: "The club name is required.",
        logo: "Logo",
        logoUploadTitle: "Choose an image or drag and drop it here.",
        logoUploadDescription: "Use a .jpg or .png image",
        logoUploadButton: "Browse image",
        logoUploadDelete: "Remove logo",
        font: "Font",
        color: "Color",
        defaultFont: "Default",
        advanced: "Advanced settings",
        showStatement: "Show statement",
        customCss: "Custom CSS",
    },
    tiers: {
        systemLabel: "Tier system",
        title: "Tiers",
        emptyTitle: "Create your tier system",
        emptyDescription: "Set up tiers to recognize customers by engagement and purchase frequency.",
        createFirst: "Create first tier",
        addLevel: "Add tier",
        panel: {
            close: "Close",
            sectionsLabel: "Tier configuration panel",
            name: "Tier name",
            namePlaceholder: "E.g., VIP, Gold, Ambassador...",
            description: "Description",
            descriptionPlaceholder: "Brief explanation of who belongs to this tier",
            segment: "Segment",
            segmentPlaceholder: "Select the segment",
            becoming: "How to reach?",
            becomingPlaceholder: "E.g., Earn 10,000 points in 12 months",
            sharedRewards: "Shared rewards",
            sharedRewardsEmpty: "No rewards configured",
            tierRewards: "Exclusive tier rewards",
            tierRewardsPlaceholder: "Add exclusive reward",
            tierColor: "Tier color",
            textColor: "Text color",
            iconType: "Icon type",
            emoji: "Emoji",
            emojiPlaceholder: "Paste an emoji here (e.g., 👑)",
            svg: "Custom icon (SVG)",
            svgPlaceholder: "Paste the <svg> code here",
            preview: "Card preview",
            cancel: "Cancel",
            save: "Save tier",
            settings: "Settings",
            design: "Design",
            iconEmoji: "Emoji",
            iconSvg: "SVG",
            previewName: "Tier name",
            previewDescription: "Tier description",
        },
        examples: {
            bronze: {
                title: "Bronze",
                description: "They are part of our active buyer group.",
            },
            silver: {
                title: "Silver",
                description: "Silver customers show purchase frequency and stronger engagement with our ecosystem.",
            },
            gold: {
                title: "Gold",
                description: "Gold customers are highly engaged and among those who get the most from our program.",
            },
        },
    },
    points: {
        systemLabel: "Points program",
        pointsFactorLabel: "How much does a customer need to spend ({currency}) to earn 1 point?",
        maxPointsPerOrderLabel: "What is the points limit per order?",
        maxPointsPerOrderPlaceholder: "No limit",
        accrualPreview: "{amount} → {points} points",
        accrualPreviewCapped: "{amount} → {points} points (per-order cap)",
        title: "Rewards",
        addReward: "Add reward",
        pointsLabel: "points",
        deleteModalTitle: "Are you sure?",
        deleteModalDescription: "This reward will be permanently removed.",
        deleteModalCancel: "Cancel",
        deleteModalConfirm: "Delete",
        deactivateModalTitle: "Deactivate points program?",
        deactivateModalDescription: "By deactivating the points program, the following active automations will be automatically paused:",
        deactivateModalEmptyDescription: "Are you sure you want to deactivate the points program?",
        deactivateModalImpactTitle: "In addition:",
        deactivateModalImpactSales: "New sales will no longer accumulate points for clients.",
        deactivateModalImpactSegments: "Segments that use points balance filters will stop updating.",
        deactivateModalImpactRewards: "Clients will not be able to redeem points rewards.",
        deactivateModalConfirm: "Deactivate program",
        emptyTitle: "Create your rewards",
        emptyDescription: "Create points program rewards to offer to your customers.",
        createFirst: "Create first reward",
        panel: {
            createTitle: "Add reward",
            editTitle: "Edit reward",
            close: "Close",
            sectionsLabel: "Reward sections",
            details: "Details",
            rules: "Rules",
            name: "Reward name",
            namePlaceholder: "E.g.: Exclusive thermal cup",
            subtitle: "Subtitle",
            subtitlePlaceholder: "E.g.: Redeem for 500 points",
            description: "Description",
            descriptionPlaceholder: "Describe the reward details...",
            image: "Image",
            imagePlaceholder: "Select an image for this reward",
            points: "Points",
            pointsPlaceholder: "E.g.: 500",
            privacy: "Privacy",
            privacyAll: "Show to everyone",
            privacyBlurred: "Show blurred to everyone",
            privacySpecific: "Customers in specific segments",
            startDate: "Start date",
            endDate: "End date",
            clearDate: "Clear",
            canUse: "Allow manual redemption by the system",
            clientCanUse: "Customer can use the reward",
            clientCanUseHintOn: "The customer redeems the reward in the app and points are deducted automatically.",
            clientCanUseHintOff: "The customer can only view the reward; redemption must be handled by staff in the system.",
            howToUse: "How to use the reward",
            howToUseInstructions: "How to use this reward?",
            howToUseInstructionsPlaceholder: "Describe the usage instructions...",
            successMessage: "Success message",
            successMessagePlaceholder: "Write what the customer will see right after redeeming the reward in the app, such as a confirmation or next-step guidance.",
            usageOption: "How the customer uses the reward",
            usageOptionRequired: "Check at least one option above: without either, the customer can neither use the reward nor know how to.",
            hasUsageInstructions: "Add usage instructions",
            usageInstructions: "Usage instructions",
            usageInstructionsPlaceholder: "E.g.: Present the code at the cashier...",
            cancel: "Close",
            save: "Save",
            saveChanges: "Save changes",
            delete: "Delete",
            deleteBlocked: "You cannot delete a reward that has already been redeemed.",
            confirmDelete: "Are you sure you want to delete this reward?",
            deleteSuccess: "Reward successfully deleted!",
            createSuccess: "Reward successfully created!",
            editSuccess: "Reward successfully saved!",
            createError: "Error creating reward.",
            editError: "Error updating reward.",
            createRewardButton: "Create reward",
            imageUploadTitle: "Choose a file or drag and drop it here.",
            imageUploadDesc: "Use 1920x1080 resolution. Only .jpg .png",
            imageUploadButton: "Browse File",
            imageUploadDelete: "Remove image",
            missingFieldsTooltip: "Please fill out required fields: {fields}"
        },
        exampleCost: "7 points",
        exampleName: "Special crust",
        exampleSubtitle: "R$13.90 coupon"
    },
    login: {
        title: "Login screen",
        background: "Background",
        solidColor: "Solid color",
        image: "Image",
        color: "Color",
        backgroundImageTitle: "Choose an image or drag and drop it here.",
        backgroundImageDescription: "Use a .jpg or .png image",
        backgroundImageButton: "Browse image",
        deleteBackgroundImage: "Delete background image",
        form: "Form",
        firstName: "First name",
        lastName: "Last name",
        birthDate: "Date of birth",
        email: "Email",
        required: "Required",
    },
    faq: {
        title: "Frequently asked questions",
        addQuestion: "Add question",
        addQuestionTitle: "Add question",
        editQuestion: "Edit question",
        editQuestionTitle: "Edit question",
        deleteQuestion: "Delete question",
        question: "Question",
        answer: "Answer",
        questionPlaceholder: "How do I redeem my points?",
        answerPlaceholder: "Enter the answer",
        introTitle: "Section title",
        introTitlePlaceholder: "Frequently asked questions",
        introShowTitle: "Show the title",
        introImage: "Image",
        introShowImage: "Show the image",
        introImageTitle: "Choose an image or drag and drop it here.",
        introImageDescription: "Use a .jpg or .png image",
        introImageButton: "Browse image",
        introImageDelete: "Delete FAQ image",
        introText: "Intro text",
        introTextPlaceholder: "Write a text shown before the questions",
        introShowText: "Show the intro text",
        close: "Close",
        saveChanges: "Save changes",
        deleteModalTitle: "Delete question",
        deleteModalDescription: "Are you sure you want to delete this question?",
        deleteModalCancel: "Cancel",
        deleteModalConfirm: "Delete",
        emptyError: "Fill in the question before saving.",
        saveError: "An error occurred while saving the question.",
        addSuccess: "Question added successfully!",
        updateSuccess: "Question updated successfully!",
        deleteSuccess: "Question removed successfully!",
        deleteError: "An error occurred while removing the question.",
    },
    terms: {
        title: "Terms and conditions",
        settings: "Settings",
        panelTitle: "Terms and conditions",
        bodyPlaceholder: "Enter the terms and conditions",
        close: "Close",
        saveChanges: "Save changes",
        success: "Terms updated successfully!",
        error: "An error occurred while saving the terms.",
    },
    banners: {
        title: "Banners",
        count: "Quantity {0}/{1}",
        dropTitle: "Choose a file or drag and drop it here.",
        dropDescription: "Use 1920x1080 resolution. Only .jpg .png",
        limitReachedTitle: "Banner limit reached",
        limitReachedDescription: "You have already added 5 banners. Delete one banner to add another.",
        searchFile: "Browse File",
        dragHandle: "Reorder banner",
        addLinkAction: "Add link",
        editLinkAction: "Edit link",
        deleteAction: "Delete banner",
        linkModalTitle: "Configure redirect link",
        linkLabel: "Link",
        copyLink: "Copy Link",
        copyLinkAgain: "Copy again",
        linkCopied: "Copied",
        linkModalSave: "Save",
        deleteModalTitle: "Delete banner",
        deleteModalDescription: "Are you sure you want to delete this banner?",
        deleteModalCancel: "Cancel",
        deleteModalConfirm: "Delete",
        statusCompleted: "Completed",
        statusUploading: "Uploading..",
        statusError: "Upload error",
    },
    colorPicker: {
        title: "Select a color",
        basics: "Basics",
        hex: "Hex",
        open: "Open color picker",
        saturationBrightness: "Saturation and brightness",
        saturationBrightnessValue: "Saturation {0}%, brightness {1}%",
        hue: "Hue",
    },
    upload: {
        oversized: "The maximum size per image is {0}MB. The following images exceeded the limit: {1}",
        parseError: "Error parsing server response.",
        serverError: "A server error occurred while trying to send the images.",
        httpError: "Error {0} during upload.",
        networkError: "Network error. Please check your internet connection.",
        success: "Upload completed successfully!",
        deleted: "Image removed successfully!",
        bannerDeleted: "Banner removed successfully!",
        deleteModalTitle: "Remove image",
        deleteModalDescription: "Are you sure you want to remove this image?",
        uploadError: "Error uploading the image.",
    },
};
